const gt = (a, b) => a > b;
export default gt;
